var GameControllerTypes;
(function (GameControllerTypes) {
    GameControllerTypes["Help"] = "help";
    GameControllerTypes["Info"] = "info1";
    GameControllerTypes["Mute"] = "music-off";
    GameControllerTypes["Music"] = "music";
    GameControllerTypes["Video"] = "video-a";
    GameControllerTypes["History"] = "history";
    GameControllerTypes["Results"] = "results";
    GameControllerTypes["Settings"] = "settings";
    GameControllerTypes["FullScreen"] = "fullscreen";
    GameControllerTypes["FullScreenOut"] = "fullscreen-out";
})(GameControllerTypes || (GameControllerTypes = {}));

export { GameControllerTypes };
